
const Footer = () => {
    return (
        <footer className="h-45 bg-gradient-rainblue pt-2">
            <div className="w-5/6 mx-auto">  
                <div className="md:flex justify-end md:justify-end text-center">
                    <p className="font-playfair font-semibold text-md">©2023 Melinda ESTEVES MENDES.</p>
                </div>    
                <div className="md:flex justify-end md:justify-end text-center pb-2">
                    <p className="font-playfair text-xs">All Rights Reserved</p>     
                </div>
            </div>
        </footer>
    )
}

export default Footer